// extracted by mini-css-extract-plugin
export var cmtFabPageWrapper = "styles-module--cmt-fab-page-wrapper--f3b06";
export var cmtFabPageWrapper__container = "styles-module--cmt-fab-page-wrapper__container--a7ab4";